window.addEventListener('DOMContentLoaded', () => {
  const pageIndices = document.querySelector('.page-indices');
  if (pageIndices) {
    pageIndices.querySelectorAll('a').forEach(indice => {
      indice.addEventListener('click', e => {
        e.preventDefault();
        const targetId = indice.getAttribute('href');
        if (window.lenis) {
          window.lenis.scrollTo(targetId, {duration: 1.5 });
        } else {
          gsap.to(window, { duration: 1.5, scrollTo: { y: targetId} });
        }
      });
    })

    // check pageIndices current status sticky or not
    const checkSticky = () => {
      const pageIndicesRect = pageIndices.getBoundingClientRect();
      pageIndices.classList.toggle('--sticky-top', pageIndicesRect.top <= 1);
    };
    window.addEventListener('scroll', checkSticky);
    checkSticky();

    pageIndices.querySelector('li:first-child a').classList.add('--active');

    const updateActiveLink = (targetId) => {
      pageIndices.querySelectorAll('a').forEach(a => a.classList.remove('--active'));
      const activeLink = pageIndices.querySelector(`a[href="#${targetId}"]`);
      if (activeLink) {
        activeLink.classList.add('--active');
      }
    };
    document.querySelectorAll('.page-index').forEach(indice => {
      const id = indice.getAttribute('id');
      ScrollTrigger.create({
        trigger: indice,
        start: 'top 10px',
        end: 'bottom 10px',
        onEnter: () => {
          updateActiveLink(id);
        },
        onEnterBack: () => {
          updateActiveLink(id);
        },
        onUpdate: self => {
          const dir = self.direction;
          pageIndices.setAttribute('data-scroll-direction', dir === 1 ? 'down' : 'up');
        }
      });
    });

    const updateCursor = () => {
      const activeLink = pageIndices.querySelector('a.--active');
      if (activeLink) {
        const rect = activeLink.getBoundingClientRect();
        const indicesRect = pageIndices.querySelector('.__projects').getBoundingClientRect();
        pageIndices.style.setProperty('--cursor-top', `${rect.top - indicesRect.top }px`);
        pageIndices.style.setProperty('--cursor-left', `${rect.left -indicesRect.left }px`);
        pageIndices.style.setProperty('--cursor-height', `${rect.height}px`);
        pageIndices.style.setProperty('--cursor-width', `${rect.width}px`);
      }
      requestAnimationFrame(updateCursor);
    }

    requestAnimationFrame(updateCursor);
  }
})


window.addEventListener('DOMContentLoaded', () => {
  const pageIndices = document.querySelector('.page-v-indices');
  if (pageIndices) {
    pageIndices.querySelectorAll('a').forEach(indice => {
      indice.addEventListener('click', e => {
        e.preventDefault();
        const targetId = indice.getAttribute('href');
        if (window.lenis) {
          window.lenis.scrollTo(targetId, {duration: 1.5 });
        } else {
          gsap.to(window, { duration: 1.5, scrollTo: { y: targetId} });
        }
      });
    })

    pageIndices.querySelector('li:first-child a').classList.add('--active');

    const updateActiveLink = (targetId) => {
      pageIndices.querySelectorAll('a').forEach(a => a.classList.remove('--active'));
      const activeLink = pageIndices.querySelector(`a[href="#${targetId}"]`);
      if (activeLink) {
        activeLink.classList.add('--active');
      }
    };
    document.querySelectorAll('.page-index').forEach(indice => {
      const id = indice.getAttribute('id');
      ScrollTrigger.create({
        trigger: indice,
        start: 'top 10px',
        end: 'bottom 10px',
        onEnter: () => {
          updateActiveLink(id);
        },
        onEnterBack: () => {
          updateActiveLink(id);
        }

      });
    });

    ScrollTrigger.create({
      trigger: '.page-index-content',
      start: 'top top',
      end: 'bottom top',
      onEnterBack: () => {
        pageIndices.classList.add('--active');
      },
      onLeaveBack: () => {
        pageIndices.classList.remove('--active');
      },
      onLeave: () => {
        pageIndices.classList.remove('--active');
      },
      onEnter: () => {
        pageIndices.classList.add('--active');
      }
    })
  }

  const tabMenu = document.querySelector('.tab-menu');
  if (tabMenu) {
    // check pageIndices current status sticky or not
    const checkTabMenuSticky = () => {
      const tabMenuRect = tabMenu.getBoundingClientRect();
      tabMenu.classList.toggle('--sticky-top', tabMenuRect.top <= 1);
    };
    window.addEventListener('scroll', checkTabMenuSticky);
    checkTabMenuSticky();
    document.querySelectorAll('[data-hide-header]').forEach(section => {
      ScrollTrigger.create({
        trigger: section,
        start: 'top 10px',
        end: 'bottom 10px',
        onUpdate: self => {
          const dir = self.direction;
          tabMenu.setAttribute('data-scroll-direction', dir === 1 ? 'down' : 'up');
        }
      });


      const activeMenu = tabMenu.querySelector(`.--active`);
      if (activeMenu) {
        tabMenu.querySelector('.__inner').scrollTo({
          left: activeMenu.offsetLeft - tabMenu.querySelector('ul').offsetLeft,
          behavior: 'smooth'
        });
      }
    })

  }
})